import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RecipesPage } from "./-RecipesPage";

const recipesSearchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_app/_shell/recipes")({
  validateSearch: (search): { q?: string } => recipesSearchSchema.parse(search),
  component: () => <RecipesPage query={Route.useSearch().q} />,
});
